import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);


import tagsView from "./modules/TagsView";
import index from "./modules/index";
import Color from "./modules/color";
import Status from './modules/status';
import tender from './modules/tender'
import tenderAcc from './modules/tenderAcc'
import sysDic from './modules/sysDic'
import message from './modules/message'

const store = new Vuex.Store({
    modules: {
        tagsView,
        index,
        Color,
        Status,
        tender,
        tenderAcc,
        sysDic,
        message
    },
    strict: false
});

export default store;



// WEBPACK FOOTER //
// ./src/store/index.js